






















































import { Vue, Component } from "vue-property-decorator";
import VueBase from "@/lib/vuebase";
import ajax from "@/lib/ajax";
import util from "@/lib/util";
import TeacherInput from "@/store/models/maintain/teacherInput";
@Component({})
export default class TeacherManager extends VueBase {
  loading: boolean = false;
  finished: boolean = false;
  error: boolean = false;
  totalCount: number = 0;
  teacherList: Array<any> = [];
  searchForm: TeacherInput = new TeacherInput();
  coachName: string = "";
  showSchool: boolean = false;
  schoolList: Array<any> = [];
  schoolShortName: string = "";
  carList: Array<string> = [];
  onClickLeft() {
    window.history.go(-1);
  }

  async getSchoolList() {
    await ajax.get("/api/school/school-to-drop-down").then((rep) => {
      this.schoolList.push(...rep.data.result);
    });
  }

  async getCarList(schoolCode: any) {
    this.carList = [];
    await ajax
      .get("/School/LoadCarList" + "?schoolCode=" + schoolCode)
      .then((rep) => {
        this.carList.push(...rep.data.result);
      });
  }

  async created() {
    await this.getSchoolList();
  }
  async onConfirmSchool(val: any) {
    console.log(val);
    this.showSchool = false;
    this.schoolShortName = val.shortName;
    await this.getCarList(val.schoolCode);
  }
}
